// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// TODO: get this from API somehow? got this list from here: http://demo.summon.serialssolutions.com/search.json?s.cmd=listFacetValues(Language,or)
const summonLanguages = [
   "Afrikaans",
   "Albanian",
   "Amharic",
   "Ancient Greek",
   "Arabic",
   "Aramaic",
   "Armenian",
   "Basque",
   "Belarusian",
   "Bengali",
   "Bosnian",
   "Breton",
   "Bulgarian",
   "Burmese",
   "Catalan",
   "Chinese",
   "Church Slavic",
   "Croatian",
   "Czech",
   "Danish",
   "Dutch",
   "English",
   "Esperanto",
   "Estonian",
   "Finnish",
   "French",
   "Gaelic",
   "Galician",
   "Georgian",
   "German",
   "Greek",
   "Gujarati",
   "Haitian",
   "Hebrew",
   "Hindi",
   "Hungarian",
   "Icelandic",
   "Indonesian",
   "Irish",
   "Italian",
   "Japanese",
   "Javanese",
   "Kannada",
   "Kazakh",
   "Korean",
   "Kurdish",
   "Latin",
   "Latvian",
   "Lithuanian",
   "Macedonian",
   "Malay",
   "Malayalam",
   "Manx",
   "Marathi",
   "Mongolian",
   "Ndonga",
   "Nepali",
   "Norwegian",
   "Norwegian Bokmål",
   "Occitan",
   "Ojibwa",
   "Old English",
   "Old French",
   "Oriya",
   "Ottoman",
   "Pali",
   "Panjabi",
   "Persian",
   "Polish",
   "Portuguese",
   "Prakrit",
   "Pushto",
   "Quechua",
   "Rajasthani",
   "Romanian",
   "Russian",
   "Sanskrit",
   "Serbian",
   "Sinhala",
   "Slavic",
   "Slovak",
   "Slovenian",
   "Spanish",
   "Swahili",
   "Swedish",
   "Syriac",
   "Tagalog",
   "Tamil",
   "Telugu",
   "Thai",
   "Tibetan",
   "Turkish",
   "Ukrainian",
   "Urdu",
   "Vietnamese",
   "Welsh",
   "Yiddish",
   "Zulu"
]

angular.module('summonApp.constants')
   .constant('$summonLanguages', summonLanguages)
